import { useTranslation } from "utilities/i18n";
import {
  DeviceLineConnection,
  useLineQueryMapped
} from "../View/Diagnostics/ServiceInformationTable";
import { TableHeader, TableRow } from "collections/Table";
import { generatePath, Link } from "polyrouter";
import React from "react";

/**
 * Sub-table (aka "Nested table") to display the lines associated with
 * a device in the device table.
 */
export function NestedLinesTable({
  deviceId,
  isPolyOs
}: {
  deviceId: string;
  isPolyOs: boolean;
}) {
  const { t } = useTranslation();
  const { lines } = useLineQueryMapped(deviceId, {
    requestPolicy: "cache-only"
  });

  if ((lines ?? []).length === 0) return <></>;

  return (
    <TableRow checked={false} className="expanded">
      <td>
        <table className="table-secondary">
          <TableHeader>
            <th>{t("LINE_NUMBER")}</th>
            <th className="connection-status fixed-width text-center">
              {t("STATUS")}
            </th>
            <th>{t("REGISTRATION_TYPE")}</th>
            <th>{t("DOMAIN")}</th>
            <th>{t("SERVER_ADDRESS")}</th>
          </TableHeader>
          <tbody>
            {lines?.slice(0, 5).map(l => (
              <TableRow checked={false} key={l.lineId}>
                <td>{l.lineId}</td>
                <DeviceLineConnection column={"STATUS"} status={l.status} />
                <td>{l.registrationType}</td>
                <td>{l.domain}</td>
                <td>{l.registrationAddress}</td>
              </TableRow>
            ))}
            <tr>
              <td colSpan={5}>
                <Link
                  to={generatePath(
                    "/manage/inventory/details/:deviceId/troubleshooting/device-information",
                    {
                      deviceId
                    }
                  )}
                >
                  {t("VIEW_ALL")}
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </TableRow>
  );
}
